import { createAction } from '@reduxjs/toolkit';

export const SET_QUOTE_DETAIL = 'SET_QUOTE_DETAIL';
export const setQuoteDetail = createAction<any>(SET_QUOTE_DETAIL);

export const UPDATE_QUOTE_DETAIL = 'UPDATE_QUOTE_DETAIL';
export const updateQuoteDetail = createAction<any>(UPDATE_QUOTE_DETAIL);
